/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate HTTP proxy
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.4-11-ge6c01455-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GroupInfoFromJSON, GroupInfoToJSON, } from './GroupInfo';
import { TargetKindFromJSON, TargetKindToJSON, } from './TargetKind';
/**
 * Check if a given object implements the TargetSnapshot interface.
 */
export function instanceOfTargetSnapshot(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('description' in value) || value['description'] === undefined)
        return false;
    if (!('kind' in value) || value['kind'] === undefined)
        return false;
    return true;
}
export function TargetSnapshotFromJSON(json) {
    return TargetSnapshotFromJSONTyped(json, false);
}
export function TargetSnapshotFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'description': json['description'],
        'kind': TargetKindFromJSON(json['kind']),
        'externalHost': json['external_host'] == null ? undefined : json['external_host'],
        'group': json['group'] == null ? undefined : GroupInfoFromJSON(json['group']),
        'defaultDatabaseName': json['default_database_name'] == null ? undefined : json['default_database_name'],
    };
}
export function TargetSnapshotToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'description': value['description'],
        'kind': TargetKindToJSON(value['kind']),
        'external_host': value['externalHost'],
        'group': GroupInfoToJSON(value['group']),
        'default_database_name': value['defaultDatabaseName'],
    };
}
